import { Grid, Icon, IconButton, InputAdornment, Tooltip } from "@mui/material";
import MDInput from "components/Basics/MDInput";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { display } from "redux-react/reducers/snackBarReducer";
import { v4 } from "uuid";

const generateHash = () => {
	return v4();
};

/**
 * Special input for webhook
 * @returns
 */
const InputApiKey = ({ label, value, onChange }) => {
	const dispatch = useDispatch();
	const [hash, setHash] = useState(value);

	// Regenerate the API key
	const regenerate = () => {
		const newHash = generateHash();
		setHash(newHash);
		onChange(newHash);
	};

	useEffect(() => {
		if (!value) {
			regenerate();
		}
	}, []);

	return (
		<Grid
			size="grow"
			sx={{
				flexBasis: "100%",
				minWidth: "100%"
			}}
		>
			<MDInput
				fullWidth
				label={label}
				value={hash}
				disabled
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							<Tooltip placement="top" title={t("SETTINGS.regenerate")}>
								<IconButton color="info" style={{ pointerEvents: "visible" }} onClick={regenerate}>
									<Icon>autorenew</Icon>
								</IconButton>
							</Tooltip>
							<Tooltip placement="top" title={t("SETTINGS.DICTIONARY.copyToClipboard")}>
								<IconButton
									color="info"
									style={{ pointerEvents: "visible" }}
									onClick={() => {
										navigator.clipboard.writeText(hash);
										dispatch(
											display({
												message: t("FORMS.copyToClipboard"),
												type: "info"
											})
										);
									}}
								>
									<Icon>copy</Icon>
								</IconButton>
							</Tooltip>
						</InputAdornment>
					)
				}}
			/>
		</Grid>
	);
};
export default InputApiKey;
